"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.getPoses = function (_a) {
  var draggable = _a.draggable,
      initialPose = _a.initialPose,
      passive = _a.passive,
      onChange = _a.onChange,
      dragBounds = _a.dragBounds,
      onDragStart = _a.onDragStart,
      onDragEnd = _a.onDragEnd,
      label = _a.label,
      ancestorValues = _a.ancestorValues,
      parentValues = _a.parentValues,
      values = _a.values,
      transitionProps = _a.transitionProps,
      poses = __rest(_a, ["draggable", "initialPose", "passive", "onChange", "dragBounds", "onDragStart", "onDragEnd", "label", "ancestorValues", "parentValues", "values", "transitionProps"]);

  return poses;
};

exports.getPoseValues = function (_a) {
  var transition = _a.transition,
      delay = _a.delay,
      delayChildren = _a.delayChildren,
      staggerChildren = _a.staggerChildren,
      staggerDirection = _a.staggerDirection,
      afterChildren = _a.afterChildren,
      beforeChildren = _a.beforeChildren,
      props = __rest(_a, ["transition", "delay", "delayChildren", "staggerChildren", "staggerDirection", "afterChildren", "beforeChildren"]);

  return props;
};

exports.getDragProps = function (_a) {
  var dragBounds = _a.dragBounds,
      onDragStart = _a.onDragStart,
      onDragEnd = _a.onDragEnd;
  return {
    dragBounds: dragBounds,
    onDragEnd: onDragEnd,
    onDragStart: onDragStart
  };
};